import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { store } from "./Redux/store/Store.js";
import Navigation from "./Routes/Navigation.jsx";

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        {/* <PersistGate loading={<ThemeSpinner />} persistor={persistor}> */}
          <BrowserRouter>
            <ToastContainer />
            <Navigation />
          </BrowserRouter>
        {/* </PersistGate> */}
      </Provider>
    </div>
  );
}

export default App;
